export const AUTH_COOKIE_NAME = 'client_auth_v2';
export const VISITOR_COOKIE_NAME = 'visitor_uuid';
